import { Injectable, Inject } from '@angular/core';
import { TRANSLATIONS } from './translations';

@Injectable()
export class TranslateService {
    private _currentLang: string;

    public get currentLang() {
        return this._currentLang;
    }


    constructor( @Inject(TRANSLATIONS) private _translations: any) {
    }

    public use(lang: string): void {

        this._currentLang = lang;
    }



    public instant(key: string) {

        return this.translate(key);
    }

    private translate(key: string): string {

        const translation = key;

        if (this._translations[this.currentLang] && this._translations[this.currentLang][key]) {
            return this._translations[this.currentLang][key];
        }

        return translation;
    }


}
